import { Environment } from './environment-type';

export const environment: Environment = {
  firebase: {
    apiKey: 'AIzaSyBqw7mPpsbC3Q42eGXqTRRlVibkq_nT-xI',
    authDomain: 'dev-test.hallohoreca.be',
    projectId: 'hospitality-takeover',
    storageBucket: 'hospitality-takeover.appspot.com',
    messagingSenderId: '960484506886',
    appId: '1:960484506886:web:0199d49583ec6b30797287',
    measurementId: 'G-D4G75PGRL1',
  },
  useEmulators: false,
  production: true,
  googleMapId: '5641ba6adfe02237',
  defaultImageUrl: 'https://storage.googleapis.com/hospitality-takeover.appspot.com/categories/cafe.jpg',
  swCheckTime: 30,
};
